import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/roofing-calculator',
  component: () => import('../../routes/RoofingCalculator.svelte'),
  card: {
    id: 'roofing-calculator',
    title: 'Roofing Calculator',
    description: 'Calculate how many squares of roofing material you need. Estimates shingles, underlayment, material cost, labor cost, and total project cost.',
    icon: 'roofing',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/roofing-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Roofing Calculator – Calculate Roofing Squares and Costs',
    description: 'Free roofing calculator to estimate how many squares of shingles you need. Calculate actual roof area, pitch multiplier, material cost, labor cost, and total project cost for any roof.',
  },
};

export default meta;